/**
 * Puente: sesión del SDK Cognito → Amplify.
 * Gen 1 firma IAM con el Identity Pool. Hace falta tokenProvider Y
 * credentialsProvider: si solo pasas tokens, Amplify no pide las credenciales AWS
 * y /me/accounts sale 401 sin firmar.
 */
import { cognitoCredentialsProvider } from 'aws-amplify/auth/cognito';
import { getCurrentSession } from './cognitoAuth';

export { cognitoCredentialsProvider };

function decodeJwt(token) {
  const parts = String(token || '').split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid token');
  }
  const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const json = decodeURIComponent(
    Array.from(atob(base64), (char) =>
      `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`
    ).join('')
  );
  return {
    payload: JSON.parse(json),
    toString: () => token,
  };
}

export const identityJsTokenProvider = {
  async getTokens(options) {
    try {
      const session = await getCurrentSession({
        forceRefresh: Boolean(options?.forceRefresh),
      });
      if (!session) return null;
      return {
        accessToken: decodeJwt(session.getAccessToken().getJwtToken()),
        idToken: decodeJwt(session.getIdToken().getJwtToken()),
      };
    } catch {
      return null;
    }
  },
};

export function clearIamCredentials() {
  return cognitoCredentialsProvider.clearCredentialsAndIdentityId();
}
